import { render, staticRenderFns } from "./Guidance.vue?vue&type=template&id=5574b1be&"
import script from "./Guidance.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Guidance.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GuidanceInline: require('C:/inetpub/wwwroot/bike-flights/components/guidance/GuidanceInline.vue').default,GuidanceHelper: require('C:/inetpub/wwwroot/bike-flights/components/guidance/GuidanceHelper.vue').default,GuidanceBanner: require('C:/inetpub/wwwroot/bike-flights/components/guidance/GuidanceBanner.vue').default})
